import { useState } from "react";
import classNames from "classnames";
import Bugsnag from "@bugsnag/js";
import styles from './SuperUserActions.module.css';
import { endFundraiserApi, requestDonationsReportApi } from "../../api/fundraisers";
import Button from "../Button";

const SuperUserActions = (props) => {
	const [endFundraiserInProgress, setEndFundraiserInProgress] = useState(false);
	const [requestDonationsReportInProgress, setRequestDonationsReportInProgress] = useState(false);

	const endFundraiser = async () => {
		if(window.confirm('Are you sure you want to end this fundraiser?')){
			setEndFundraiserInProgress(true);
			const endFundraiserResponse = await endFundraiserApi(props.fundraiserId);
			let body;
			try{
				body = await endFundraiserResponse.json();
			}
			catch(e){}
			if(endFundraiserResponse && endFundraiserResponse.ok){
				props.endFundraiser();
				props.updateFundraiserEndAt(body.data.change_history_id, (new Date().toISOString()));
			}
			else{
				Bugsnag.notify(body?.error ? body.error : 'End fundraiser failed');
				alert('Something went wrong. Fundraiser was not ended');
			}
			setEndFundraiserInProgress(false);
		}
	};

	const requestDonationsReport = async () => {
		setRequestDonationsReportInProgress(true);
		const requestDonationsReportResponse = await requestDonationsReportApi(props.fundraiserId);
		let body;
        try{
            body = await requestDonationsReportResponse.json();
        }
        catch(e){}
        if(requestDonationsReportResponse && requestDonationsReportResponse.ok){
			alert('Report has been e-mailed to you');
        }
		else{
			Bugsnag.notify(body?.error ? body.error : 'Send fundraiser donations report failed');
			alert('Something went wrong. Report was not sent');
		}
		setRequestDonationsReportInProgress(false);
	};

	return (
		<div className={classNames(styles.container, props.className)}>
			<div>
				{
					props.status === 'in-progress' && (
						<Button className={styles.endFundraiserButton} text="End fundraiser" dark={true} onClick={() => endFundraiser()} disabled={endFundraiserInProgress}/>
					)
				}
				{
					props.donations?.length > 0 && (
						<Button className={styles.requestDonationsReportButton} text="Request donations report" onClick={() => requestDonationsReport()}
								disabled={requestDonationsReportInProgress}/>
					)
				}
			</div>
		</div>
	)
};

export default SuperUserActions;